import api from '~/services/api';

const getAllServiceLevels = () =>
  api.request({
    method: 'GET',
    params: {
      use_database: true,
    },
    url: `/api_account/service_levels`,
  });

export { getAllServiceLevels };
